import { useQueryData } from "hooks";
import { GET_DATA_FRESHNESS_TIMESTAMPS } from "graphql/queries";

/**
 * useDataFreshnessTimestamps
 *
 * A hook to fetch data freshness timestamps from the data service.
 * This provides information about when each data source was last synced.
 *
 * @returns {Object} Object containing timestamps for all data sources
 */
export default function useDataFreshnessTimestamps() {
  const { data, loading, error } = useQueryData({
    queryName: GET_DATA_FRESHNESS_TIMESTAMPS,
    skip: false,
  });

  return {
    timestamps: data?.dataFreshnessTimestamps || {},
    loading,
    error,
  };
}
